<template>
  <div class="form-builder assignment assignment-view">
    <div class="assignment-desc">
      <div class="md-layout-item">
        <div class="md-layout align-center">
          <div class="assignment-image md-layout-item">
            <img alt src="./assets/assignment_icon.svg" />
          </div>
          <div class="assignment-label md-layout-item">
            <div class="status">
              <span v-if="assignment_submission.status == $assignment_status.ASSIGNMENT_REVIEW_NEEDED || assignment_submission.status == $assignment_status.ASSIGNMENT_COMPLETED ">
                {{ $assignment_status_text[$assignment_status.ASSIGNMENT_REVIEW_NEEDED] }}
              </span>
            </div>
            <div class="label-text" v-text="title"></div>
            <div>{{ coach }}</div>
            <div>
              {{ dueDate ? "Due " + $moment(dueDate).format("MMMM DD") : "" }}
            </div>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item"></div>
        </div>
      </div>
    </div>
    <md-card class="assignment-card">
      <md-card-content>
        <h2>Instructions</h2>
        <div class="text-left clear-both" v-html="description"></div>
        <div
          class="text-left clear-both"
          v-bind:key="index"
          v-for="(val, index) in assignmentLinks"
        >
          <component
            :data-props="val"
            :no-delete="true"
            :clean-error="cleanError"
            upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
            :is="val.type == 'link' ? 'FbFileViewLink' : 'FbFileViewFile'"
          />
        </div>
        <div
          class="text-left clear-both"
          v-bind:key="index"
          v-for="(val, index) in assignmentVideos"
        >
          <component
            :data-props="val"
            :no-delete="true"
            :clean-error="cleanError"
            upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
            :is="'FbVideoViewFile'"
            :sid="uuid"
            :assignment="assignment_submission.assignment.uuid"
            :allowCommenting="true"
          />
        </div>
      </md-card-content>
    </md-card>
    <div
      v-show="showSuccessMessage"
      class="no-line text-left success-message-wrapper"
    >
      <div class="success-message">Assignment submitted successfully!</div>
    </div>
    <md-card
      v-show="
        assignment_submission &&
        assignment_submission.assignment &&
        !!+assignment_submission.assignment.submission_required
      "
      class="assignment-card"
    >
      <md-card-content>
        <h2>Your Submission</h2>
        <div
          class="text-left clear-both"
          v-if="assignment_submission.status == $assignment_status.ASSIGNMENT_COMPLETED"
          v-html="submissionText"
        ></div>
        <div class="assignment-section">
          <fb-rich-text
            v-if="assignment_submission.status != $assignment_status.ASSIGNMENT_COMPLETED"
            v-model="submissionText"
            :uuid="$uuid.v1()"
            :mode="true"
            :element="{ data: { value: submissionText } }"
            editor_format="client_full_html"
          />
          <fb-file-view
            :data-props="links"
            v-if="assignment_submission.status != $assignment_status.ASSIGNMENT_COMPLETED"
            @update-links="updateLinks"
            @update-files="updateFiles"
            @update-error="updateError(true)"
            :nid="nid"
          />
          <div
            class="text-left"
            v-bind:key="index"
            v-for="(val, index) in links"
          >
            <component
              @delete="del(index)"
              @upload-file="fileUploaded(index, 'links', $event)"
              @upload-file-fail="fileUploadFail(index, $event)"
              :data-props="val"
              :clean-error="cleanError"
              :no-delete="
                assignment_submission.status == $assignment_status.ASSIGNMENT_COMPLETED
              "
              upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
              @update-error="updateError(false)"
              :is="val.type == 'link' ? 'FbFileViewLink' : 'FbFileViewFile'"
            />
          </div>
          <fb-video-view
            v-if="assignment_submission.status != $assignment_status.ASSIGNMENT_COMPLETED"
            :data-props="videos"
            @update-files="updateFiles($event, 'videos')"
            @update-error="updateError(true)"
            :nid="nid"
            class="video-view"
          />
          <div
            class="text-left"
            v-bind:key="index"
            v-for="(val, index) in videos"
          >
            <component
              @delete="del(index, 'videos')"
              @upload-file="fileUploaded(index, 'videos', $event)"
              @upload-file-fail="fileUploadFail(index, 'videos', $event)"
              :data-props="val"
              :clean-error="cleanError"
              upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
              @update-error="updateError(false)"
              :is="'FbVideoViewFile'"
              :sid="uuid"
              :no-delete="
                assignment_submission.status == $assignment_status.ASSIGNMENT_COMPLETED
              "
            />
          </div>
        </div>
        <div v-if="assignment_submission.status != $assignment_status.ASSIGNMENT_COMPLETED" class="submit-wrapper">
          <div v-if="submitError" class="submit-error">
            <div class="messages messages--error">Please add text, a file, a link, or a video.</div>
          </div>
          <div class="md-layout-item md-layout md-alignment-center-center">
            <md-button
                    class="md-primary md-feedback icon-right fb-submit-btn right"
                    @click="save"
            >
              Submit
              <md-icon>send</md-icon>
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div v-if="feedback" class="feedback-view text-left">
      <b>Feedback:</b>
      <p v-html="feedback" class="feedback-text text-left"></p>
    </div>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import HelpersMixin from "./HelpersMixin";
import Spinner from "./components/Spinner.vue";
import FbFileView from "./components/Form/FbFile/FbFileView";
import FbFileViewFile from "./components/Form/FbFile/FbFileViewFile.vue";
import FbFileViewLink from "./components/Form/FbFile/FbFileViewLink.vue";
import FbVideoView from "./components/Form/FbVideo/FbVideoView";
import FbVideoViewFile from "./components/Form/FbVideo/FbVideoViewFile.vue";

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate", "editMode"],
  mixins: [HelpersMixin],
  data() {
    return {
      showSuccessMessage: false,
      assignment_submission: window.drupalSettings.assignment_submission || {},
      uuid: window.drupalSettings.assignment_submission.uuid || null,
      assignmentLinks:
        window.drupalSettings.assignment_submission.assignment.links || [],
      assignmentVideos:
        window.drupalSettings.assignment_submission.assignment.videos || [],
      links: window.drupalSettings.assignment_submission.links || [],
      videos: window.drupalSettings.assignment_submission.videos || [],
      image: null,
      dueDate:
        window.drupalSettings.assignment_submission.assignment.due_date || null,
      title:
        window.drupalSettings.assignment_submission.assignment.title || null,
      description:
        window.drupalSettings.assignment_submission.assignment.description ||
        "",
      coach:
        window.drupalSettings.assignment_submission.assignment.coach.name || "",
      feedback: window.drupalSettings.assignment_submission.feedback || null,
      showLoader: false,
      cleanError: false,
      submitError: false,
      submissionText:
        (window.drupalSettings.assignment_submission.data &&
          window.drupalSettings.assignment_submission.data) ||
        "",
    };
  },
  components: {
    Spinner,
    FbFileView,
    FbFileViewFile,
    FbFileViewLink,
    FbVideoViewFile,
    FbVideoView,
  },
  computed: {
    valid() {
      let hasText = this.submissionText != "";
      let hasLinkOrFile = this.links.length != 0;
      let hasVideo = this.videos.length != 0;

      // Check not valid files.
      let files = this.links.filter((link) => {
        return link.type == "file";
      });
      if (hasLinkOrFile && files.length == this.links.length) {
        for (var key in files) {
          if (files[key]['filemime'] == '') {
            hasLinkOrFile = false;
            break;
          }
        }
      }

      let result = hasText || hasLinkOrFile || hasVideo;
      this.submitError = !result;
      return result;
    },
  },
  methods: {
    updateError(value) {
      this.cleanError = value;
    },
    updateLinks(links) {
      this.submitError = false;
      this.links = this.links.concat(
        links.map((el) => {
          return {
            link: el,
            type: "link",
          };
        })
      );
    },
    updateFiles(file, key) {
      if (!key) {
        key = "links";
      }
      this[key] = this[key].concat([
        {
          link: file.name,
          type: "file",
          buffer: file.buffer,
          name: file.name,
          uuid: "",
          uri: "",
          filemime: "",
        },
      ]);
    },
    fileUploaded(index, key, file) {
      if (!key) {
        key = "links";
      }
      this[key][index].name = file.name;
      this[key][index].uuid = file.uuid;
      this[key][index].uri = file.uri;
      this[key][index].filemime = file.filemime;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    fileUploadFail(index, key) {
      if (!key) {
        key = "links";
      }
      this[key].splice(index, 1);
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
      this.submitError = false;
    },
    del(index, key) {
      if (!key) {
        key = "links";
      }
      this[key].splice(index, 1);
    },
    save() {
      this.validate = true;
      this.isDraft = false;
      this.showSuccessMessage = false;
      if (!this.valid) {
        return;
      }
      this.showLoader = true;
      return this.sendAssignmentRequest(true, false)
        .then(() => {
          window.location.href = "/frontpage";
          // this.showLoader = false;
          // this.showSuccessMessage = true;
          return true;
        })
        .catch((e) => {
          this.showLoader = false;
          this.showSuccessMessage = false;
          // TODO: Add error you page
          throw new Error(e);
        });
    },
    sendAssignmentRequest(isDraft, isStarted) {
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "PATCH";
        let value = {
          date: this.date,
        };
        value.isDraft = isDraft;
        value.isStarted = isStarted;
        let files = this.links.filter((link) => {
          return link.type == "file";
        });
        files = files.concat(
          this.videos.filter((video) => {
            return video.type == "file";
          })
        );
        let a_data = {
          data: {
            type: "assignment_submission--assignment_submission",
            attributes: {
              links_files: JSON.stringify(this.links),
              videos: JSON.stringify(this.videos),
              data: this.submissionText,
            },
            relationships: {
              attached_file:
                files.length === 0
                  ? null
                  : {
                      data: files.map((file) => {
                        return {
                          type: "file--file",
                          id: file.uuid,
                        };
                      }),
                    },
            },
          },
        };
        let url = "/jsonapi/assignment_submission/assignment_submission";

        url += "/" + this.uuid;
        a_data.data.id = this.uuid;

        return fetch(url, {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify(a_data),
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json && json.errors && json.errors.length) {
              throw new Error(json.errors[0].title);
            }
            return json;
          });
      });
    },
  },
};
</script>
<style lang="scss">
.clear-both {
  &::after {
    display: block;
    content: "";
    clear: both;
  }
}
.feedback-view {
  margin-top: 24px;
  border-radius: 20px;
  background: $blue-dark;
  padding: 10px 24px;
  color: #fff;
  .feedback-text {
    color: rgb(60, 60, 60);
    padding: 10px;
    font-size: 16px;
    font-weight: normal;
    background-color: #ffffff;
    border-radius: 10px;
  }
}
.success-message-wrapper {
  margin-bottom: 24px;
}
.assignment-view {
  .status {
    color: rgb(255, 255, 255);
    font-family: $font-filson-soft;
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    opacity: 0.5;
  }
  .assignment-section {
    padding-left: 0px;
    padding-right: 0px;
    .video-view .upload-link {
      display: block;
    }
    .md-layout.align-left {
      float: none;
    }
    .messages--error.file-error {
      margin-top: 0;
    }
  }
  .submit-wrapper {
    display: block;
  }
}
.assignment-desc {
  background-color: $blue-dark !important;
  background-position: center bottom;
  padding-top: 20px;
  padding-bottom: 10px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  min-height: 180px;
  .assignment-image {
    width: 140px;
    max-width: 140px;
    margin-right: 32px;
    > img {
      transition: $transition;
      transition: var(--transition);
    }
    &:hover {
      > img {
        transform: scale(1.1);
      }
    }
  }
  .assignment-label {
    width: 100%;
    color: #ffffff;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    font-family: $font-source-sans-pro;
    .label-text {
      font-family: $font-filson-soft;
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 15px;
      //overflow: unset;
    }
  }
}
</style>
